<template>
  <div>
    <span v-if="getIsShow">抱歉,未搜索到商品</span>
    <span v-for="number1 in itemCount" :key="number1">
      <el-row :gutter="20">
        <el-col :span="6" v-for="number2 in 4" :key="number2" v-if="(number1-1)*4+number2-1<itemList.length">
          <div class="grid-content bg-purple">
            <router-link :to="'/item/desc?itemId='+itemList[(number1-1)*4+number2-1].id">
              <el-image style="width: 100%; height: 100%" :src="itemList[(number1-1)*4+number2-1].path" fit="fill"></el-image>
            </router-link>
          </div>
          <router-link :to="'/item/desc?itemId='+itemList[(number1-1)*4+number2-1].id"><span>{{itemList[(number1-1)*4+number2-1].name}}</span></router-link><br />
        </el-col>
      </el-row>
    </span>
  </div>
</template>

<script>
  import {
    getItem,
  } from '@/api/item.js'
  import Vuex from 'vuex';

  export default {
    name: "ItemMenu",
    data: function() {
      return {
        itemList: [],
        isShow: false,
      }
    },
    computed: {
      itemCount: function() {
        return Math.ceil(this.itemList.length / 4);
      },
      getIsShow: function() {
        return this.$data.isShow;
      }
    },
    methods: {},
    created() {
      if (this.$route.path == "/item/search") {
        this.$store.state.myactive = "0"
        var keyword = this.$route.query.keyword;
        getItem("item/get?keyword=" + keyword, this.$data, "1");
      } else {
        var nid = this.$route.query.nid;
        if (nid != null && nid != "") {
          getItem("item/get?nid=" + nid, this.$data, "2");
        } else {
          getItem("item/get?nid=1", this.$data, "2");
          this.$store.state.myactive = "1"
        }
      }
    },
  }
</script>

<style>
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    height: 230.6px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>



// WEBPACK FOOTER //
// src/components/item/ItemMenu.vue